var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cl_add_edit_title"},[_c('div',{staticClass:"c_title mb16"},[_c('span',{staticClass:"c_border pb12 fs16 SysFontM Major_Color"},[_vm._t("default")],2),_c('span',{staticClass:"c_right"},[_vm._t("right")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }